module.exports = __webpack_public_path__ + "img/89.67fe25e4.jpg";